import React, { useState, FunctionComponent } from "react";
import {
  Paper,
  Button,
  Grid,
  Typography,
  TextField
} from "@material-ui/core";
import { SnackBar } from "../../SnackBar";
import { Formik, Form, ErrorMessage } from "formik";
import { useUsersStyles } from "../useUsersStyles";
import { Select } from "../../Select";
import { useStore } from "../../../store";
import * as yup from "yup";

const updateSchema = yup.object().shape({
  full_name: yup.string().required("Name is required"),
  user_code: yup
    .string()
    .min(2, "Too Short!")
    .max(70, "Too Long!")
    .required("Username is required"),

  division_id: yup
    .string()
    .required("Division is required")
    .nullable(),
  status: yup
    .string()
    .required("Status is required")
    .nullable(),
  user_type: yup
    .string()
    .required("Roles are required")
    .nullable(),
});

type userParams = {
  userId: string;
  goBackToList: () => void;
};
export const POSUserForm: FunctionComponent<userParams> = ({
  userId,
  goBackToList,
}) => {
  const classes = useUsersStyles();
  const [posUsers, { updatePOSUser, getPosUsers }] = useStore("posUsers");
  const [userDivisions] = useStore("userDivisions");
  const [status] = useStore("status");
  const [userTypes] = useStore("userTypes");

  const [snackbarColor, setSnackbarColor] = useState<string>("#d50000");
  const [userStatus, setUserStatus] = useState<string>("");
  const [usernameAvailable, setusernameAvailable] = useState<any>(null);

  const divisionOptions =
    userDivisions &&
    userDivisions.map((item: { [key: string]: any }) => ({
      value: item.id,
      label: item.name,
    }));
  const statusOptions =
    status &&
    status.map((item: { [key: string]: any }) => ({
      value: item.id,
      label: item.description,
    }));
  const userTypeOptions =
    userTypes &&
    userTypes.map((item: { [key: string]: any }) => ({
      value: item.id,
      label: item.name,
    }));
  const userDetails =
    posUsers && posUsers !== undefined
      ? Object.values(posUsers && posUsers).find(
        (value: any) => value.id === userId
      )
      : "";
  const initialValues = {
    full_name: userDetails !== undefined ? userDetails.full_name : null,
    user_code: userDetails !== undefined ? userDetails.user_code : null,
    status: statusOptions.find((item: any) =>
      userDetails !== undefined ? userDetails.status === item.value : null
    ),
    division_id: divisionOptions.find((item: any) =>
      userDetails !== undefined ? userDetails.division_id === item.value : null
    ),
    user_type: userTypeOptions.find((item: any) =>
      userDetails !== undefined ? userDetails.user_type === item.value : null
    ),
  };

  const checkAvailability = (value: any) => {
    const user_code_list =
      posUsers && posUsers !== undefined
        ? Object.values(posUsers && posUsers).map(
          (value: any) => value.user_code
        )
        : "";

    if (user_code_list.includes(value)) {
      setusernameAvailable(false);
    } else {
      setusernameAvailable(true);
    }
  };
  const submitForm = async (values: any) => {
    try {
      const POSUserUpdateData = {
        full_name: values.full_name,
        user_code: values.user_code,
        status: values.status.value,
        division_id: values.division_id.value,
        user_type: values.user_type.value,
      };
      await updatePOSUser(userId, POSUserUpdateData);
      getPosUsers();
      setSnackbarColor("green");
      setUserStatus("User successfully updated");
      setTimeout(() => {
        //setNavigateToUserTable(true);
        goBackToList();
      }, 2000);
    } catch (error) {
      checkAvailability(values.user_code);
      if (usernameAvailable) {
        setSnackbarColor("red");
        setUserStatus(error.error);
      } else {
        setSnackbarColor("red");
        setUserStatus("Username already exist");
      }
    }
  };
  const onCloseSnackbar = () => {
    setUserStatus("");
  };
  return (
    <div>
      <SnackBar
        status={userStatus}
        onCloseError={onCloseSnackbar}
        color={snackbarColor}
      />
      {/* <Grid item>
          <Typography className={classes.userTitle}> {"Edit User"}</Typography>
        </Grid> */}
      <Paper elevation={4} style={{ minHeight: "25em", minWidth: "50%" }}>
        <Grid item>
          <Formik
            enableReinitialize
            validationSchema={updateSchema}
            initialValues={initialValues}
            onSubmit={(values) => {
              submitForm(values);
            }}
          >
            {({ values, handleChange, setFieldValue, resetForm }) => (
              <Form>
                <Grid container direction="row">
                  <Grid item xs>
                    <Grid
                      container
                      spacing={5}
                      className={classes.fieldSpace}
                    >
                      <Grid item xs={6}>
                        <Typography className={classes.fieldLabelStyles}>
                          Full Name
                          </Typography>
                        <TextField
                          variant="outlined"
                          name="full_name"
                          value={values.full_name}
                          onChange={handleChange}
                          inputProps={{ maxLength: 50 }}
                          fullWidth={true}
                        />

                        <ErrorMessage name="full_name">
                          {(msg) => <div style={{ color: "red" }}>{msg}</div>}
                        </ErrorMessage>
                      </Grid>
                      <Grid item xs={6}>
                        <Typography className={classes.fieldLabelStyles}>
                          Username
                          </Typography>
                        <TextField
                          variant="outlined"
                          name="user_code"
                          value={values.user_code}
                          onChange={handleChange}
                          inputProps={{ maxLength: 50 }}
                          fullWidth={true}
                          disabled={true}
                        />

                        <ErrorMessage name="user_code">
                          {(msg) => <div style={{ color: "red" }}>{msg}</div>}
                        </ErrorMessage>
                      </Grid>
                      <Grid item xs={6}>
                        <Typography
                          style={{ textAlign: "left" }}
                          className={classes.fieldLabelStyles}
                        >
                          Role
                          </Typography>
                        <Select
                          style={{ height: "2em" }}
                          onChange={(value: any) => {
                            setFieldValue("user_type", value);
                          }}
                          options={userTypeOptions}
                          value={values.user_type}
                        ></Select>
                        <ErrorMessage name="user_type">
                          {(msg) => <div style={{ color: "red" }}>{msg}</div>}
                        </ErrorMessage>
                      </Grid>

                      <Grid item xs={6}>
                        <Typography
                          style={{ textAlign: "left" }}
                          className={classes.fieldLabelStyles}
                        >
                          Division
                          </Typography>
                        <Select
                          style={{ height: "2em" }}
                          onChange={(value: any) => {
                            setFieldValue("division_id", value);
                          }}
                          options={divisionOptions}
                          value={values.division_id}
                        ></Select>
                        <ErrorMessage name="division_id">
                          {(msg) => <div style={{ color: "red" }}>{msg}</div>}
                        </ErrorMessage>
                      </Grid>

                      <Grid item xs={6}>
                        {/* <Typography>Status</Typography>
                        <Select
                          style={{ height: "2em" }}
                          onChange={(value: any) => {
                            setFieldValue("status", value);
                          }}
                          options={statusOptions}
                          value={values.status}
                          fullWidth={true}
                        ></Select>
                        <ErrorMessage name="status">
                          {(msg) => <div style={{ color: "red" }}>{msg}</div>}
                        </ErrorMessage> */}
                      </Grid>

                      {/*create form button */}
                      <Grid item xs={6} sm={6}>
                        <Grid
                          container
                          direction="row"
                          spacing={1}
                          justify="flex-end"
                          alignItems="flex-end"
                          className={classes.buttonPosition}
                        >
                          <Grid
                            item
                            xs={6}
                            sm="auto"
                            className={classes.buttonStyle}
                          >
                            <Button
                              variant="contained"
                              color="primary"
                              type="reset"
                              size="medium"
                            >
                              <Typography>Clear</Typography>
                            </Button>
                          </Grid>
                          <Grid
                            item
                            xs={6}
                            sm="auto"
                            className={classes.buttonStyle}
                          >
                            <Button
                              variant="contained"
                              color="primary"
                              type="submit"
                              size="medium"
                            >
                              <Typography>Submit</Typography>
                            </Button>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Form>
            )}
          </Formik>
        </Grid>
      </Paper>
    </div>
  );
};
